var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupplytrackerCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.565 3.5H8V328.674M504.565 3.5V328.674H8M504.565 3.5L521 19.9348V345.108H24.4348L8 328.674",
    stroke: "#32BB79",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 328.674L24.5 345.108H521L504.565 328.674H8.5Z",
    fill: "#20955D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M521 345.108V19.9348L504.565 3.5V328.674L521 345.108Z",
    fill: "#32BB79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174 90H356V258.5H174L174 90ZM345.025 133.66V107H184.518V133.66H345.025ZM345.025 145.611H184.518V172.271H345.025V145.611ZM345.025 184.682H184.518V211.342H345.025V184.682ZM345.025 235.517H300.211V250.686H345.025V235.517Z",
    fill: "#32BB79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 368.5V345.5H521.426V0.5H544.5V368.5H0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplytrackerCap);
export default __webpack_public_path__ + "static/media/supplytracker-cap.afe10191bee1c6a009c7d2334e1cadb4.svg";
export { ForwardRef as ReactComponent };